







































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    "tax-templates-provider": () =>
      import("@/components/app/global/tax/templates/taxTemplatesProvider.vue")
  }
})
export default class TaxTemplatesSelect extends Vue {
  // Prop
  @Prop({ required: true })
  public readonly value!: number;

  @Prop({ default: false })
  public readonly isDisabled!: boolean;

  // Methods
  public onInput(value) {
    this.$emit("input", value);
  }
}
